import request from '@/utils/request'
import { Modal } from 'ant-design-vue'
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}
export function formatSecondsToDay(totalSeconds) {
  const days = Math.floor(totalSeconds / (3600 * 24))
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const remainingSeconds = totalSeconds % 60
  const padZero = (num) => (num < 10 ? '0' + num : num)
  return `${days}天${padZero(hours)}时${padZero(minutes)}分${padZero(remainingSeconds)}秒`
}
export function formatSecondsTohms(totalSeconds) {
  if (!totalSeconds) return `00时00分00秒`
  let secondTime = parseInt(totalSeconds) // 秒
  let minuteTime = 0 // 分
  let hourTime = 0 // 时
  let dayTime = 0
  if (secondTime > 60) {
    minuteTime = parseInt(secondTime / 60)
    secondTime = parseInt(secondTime % 60)
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60)
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  const padZero = (num) => (num < 10 ? '0' + num : num)
  return `${padZero(hourTime)}时${padZero(minuteTime)}分${padZero(secondTime)}秒`
}
export function formatSecondsTohmsOther(totalSeconds) {
  if (!totalSeconds) return `00时00分00秒`
  let secondTime = parseInt(totalSeconds) // 秒
  let minuteTime = 0 // 分
  let hourTime = 0 // 时
  let dayTime = 0
  if (secondTime > 60) {
    minuteTime = parseInt(secondTime / 60)
    secondTime = parseInt(secondTime % 60)
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60)
      minuteTime = parseInt(minuteTime % 60)
    }
  }
  const padZero = (num) => (num < 10 ? '0' + num : num)
  return `${padZero(hourTime)}:${padZero(minuteTime)}:${padZero(secondTime)}`
}
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    (event) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}
export function scorePassword(pass) {
  let score = 0
  if (!pass) {
    return score
  }
  // award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  }

  let variationCount = 0
  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0
  }
  score += (variationCount - 1) * 10

  return parseInt(score)
}
export const detectZoom = () => {
  let ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase()
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth
  }
  if (ratio) {
    ratio = Math.round(ratio * 100)
  }
  return ratio
}
//获取视频的宽高
export const getVideoWidth = (fileUrl) => {
  return new Promise((resolve, reject) => {
    let aspectRatio = null
    let url = fileUrl
    const newvideoUrl = url
    const videoObj = document.createElement('video')
    videoObj.preload = 'metadata'
    videoObj.src = newvideoUrl
    videoObj.onloadedmetadata = function (evt) {
      console.log('getVideoWidth>>', width, height, newvideoUrl)
      URL.revokeObjectURL(newvideoUrl)
      let videoTime = videoObj.duration // 获取视频的时长
      let width = videoObj.videoWidth //获取视频的宽
      let height = videoObj.videoHeight //获取视频的高
      resolve({ width, height })
    }
  })
}
//图片的宽高
export const getImageWidth = (fileUrl) => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.src = url
    img.onload = function (image) {
      resolve({ width: img.width, height: img.height })
    }
  })
}
/**
 * 获取视频的封面图信息
 * @param url 视频地址
 * @param second 秒数
 */
export const getVideoBase64 = (url, second = 0) => {
  const video = document.createElement('video')
  video.setAttribute('crossOrigin', 'anonymous') // 处理跨域
  video.setAttribute('src', url)
  // 静音操作，防止播放失败
  video.setAttribute('muted', 'muted')
  video.addEventListener('loadeddata', async () => {
    const canvas = document.createElement('canvas')
    const { width, height } = video // canvas的尺寸和图片一样
    canvas.width = width
    canvas.height = height

    if (second) {
      video.currentTime = second
      // 播放到当前时间的帧，才能截取到当前的画面
      await video.play()
      await video.pause()
    }

    canvas.getContext('2d')?.drawImage(video, 0, 0, width, height)
    return canvas.toDataURL('image/jpeg')
  })
}
/**
 * 获取视频的封面图信息
 * @param url 视频地址
 * @param second 秒数
 */
export const generateThumbnail = (videoFile, callback) => {
  const video = document.createElement('video')
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  // 加载视频文件
  video.src = URL.createObjectURL(videoFile)
  video.onloadedmetadata = function () {
    // 设置 canvas 的尺寸和视频尺寸一致
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight

    // 在 canvas 上绘制视频的第一帧
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

    // 将 canvas 转换为缩略图的 Data URL
    const thumbnailDataUrl = canvas.toDataURL('image/jpeg')

    // 调用回调函数，将缩略图的 Data URL 作为参数传递
    //callback(thumbnailDataUrl);
    return thumbnailDataUrl
  }
}

/**
 * 获取视频的封面图信息
 * @param url 视频地址
 * @param second 秒数
 */
export const generateThumbnail2 = (videoData) => {
  // 创建一个video元素用于生成缩略图
  const videoElement = document.createElement('video')
  videoElement.addEventListener('loadedmetadata', function () {
    // 设置video元素的时间戳，可以选择任意时间点的帧生成缩略图
    videoElement.currentTime = 5 // 这里设置为第5秒的帧
  })

  // 将视频数据绑定到video元素上
  const videoBlob = new Blob([videoData])
  videoElement.src = URL.createObjectURL(videoBlob)

  // 监听视频帧加载完成事件
  videoElement.addEventListener('seeked', function () {
    // 创建canvas元素用于绘制缩略图
    const canvas = document.getElementById('thumbnailCanvas')
    const context = canvas.getContext('2d')
    canvas.width = videoElement.videoWidth
    canvas.height = videoElement.videoHeight

    // 在canvas上绘制视频帧
    context.drawImage(videoElement, 0, 0, canvas.width, canvas.height)

    // 将缩略图数据转换为文件对象
    canvas.toBlob(uploadThumbnail, 'image/jpeg')
  })
}

export const uploadFileList = (url, params) => {
  let config = {
    // 添加请求头
    headers: {
      'Content-Type': 'multipart/form-data',
      //'Authorization': Vue.cookie.get('Authorization_vs') // 请求头带上token
    },
  }
  // 一般参数可以正常序列化并传递，传文件的文件流是无法被序列化并传递的；
  // 使用formData对象序列化要传递的参数，就可以进行文件上传了。
  let param = new FormData()
  // 通过append向form对象添加数据
  Object.keys(params).forEach((key) => {
    const val = params[key]
    // 附件是以二进制流数组格式传进来，拆分成一个个相同key的项，放在载荷里面给后端上传；
    // 但后端实际上收到的还是一个数组，只不过前端载荷是若干个相同key的参数。
    if (Array.prototype.isPrototypeOf(val)) {
      val &&
        val.map((file) => {
          param.append(key, file)
        })
    } else {
      // 其他参数正常key上传
      param.append(key, val)
    }
  })
  return this.$http.post(url, param, config) // post请求（可以改成get请求）
}

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
export const removeUndefinedNullAndSpaces = (str) => {
  if (typeof str === 'string') {
    // 去除首尾空格
    str = str.trim()
    // 替换连续换行符为单个换行符
    str = str.replace(/\n+/g, '\n')
    // 判断是否为 undefined 或 null
    if (str === 'undefined' || str === 'null' || str === undefined || str === null) {
      return ''
    }
    return str
  }
  return ''
}
export const unsecuredCopyToClipboard = (text) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  try {
    document.execCommand('copy')
    Modal.success({
      content: <span>直播地址已复制到剪切板啦.</span>,
      centered: true,
      okText: '确认',
    })
  } catch (err) {
    console.error('Unable to copy to clipboard', err)
  }
  document.body.removeChild(textArea)
}

/**
 * Copies the text passed as param to the system clipboard
 * Check if using HTTPS and navigator.clipboard is available
 * Then uses standard clipboard API, otherwise uses fallback
 */
export const copyToClipboard = (content) => {
  if (window.isSecureContext && navigator.clipboard) {
    navigator.clipboard.writeText(content)
  } else {
    unsecuredCopyToClipboard(content)
  }
}
export const getParameterByName = (name) => {
  const url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
//后端数据库时间格式2024-06-28T09:52:00.000+00:00转换为YYYY-MM-DD HH:mm:ss
export const  formatDateIsoString=(isoString) => {
  const date = new Date(isoString);
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
}
//【0，100】内数字转大写
export const numberToChinese=(value)=> {
  const chineseNumbers = [
    '零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
    '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
    '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七', '二十八', '二十九', '三十',
    '三十一', '三十二', '三十三', '三十四', '三十五', '三十六', '三十七', '三十八', '三十九', '四十',
    '四十一', '四十二', '四十三', '四十四', '四十五', '四十六', '四十七', '四十八', '四十九', '五十',
    '五十一', '五十二', '五十三', '五十四', '五十五', '五十六', '五十七', '五十八', '五十九', '六十',
    '六十一', '六十二', '六十三', '六十四', '六十五', '六十六', '六十七', '六十八', '六十九', '七十',
    '七十一', '七十二', '七十三', '七十四', '七十五', '七十六', '七十七', '七十八', '七十九', '八十',
    '八十一', '八十二', '八十三', '八十四', '八十五', '八十六', '八十七', '八十八', '八十九', '九十',
    '九十一', '九十二', '九十三', '九十四', '九十五', '九十六', '九十七', '九十八', '九十九', '一百'
  ];

  if (value < 0 || value > 100) {
    return value;
  }

  return chineseNumbers[value];
}

// console.log(chineseNumbers);